import { render, staticRenderFns } from "./bModal.vue?vue&type=template&id=b3151bf8&scoped=true"
import script from "./bModal.vue?vue&type=script&lang=ts"
export * from "./bModal.vue?vue&type=script&lang=ts"
import style0 from "./bModal.vue?vue&type=style&index=0&id=b3151bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3151bf8",
  null
  
)

export default component.exports